export const removeDiacritics = (str: string): string =>
  str.normalize("NFD").replace(/[\u0300-\u036f]/g, ""); // "příliš žluťoučký kůň úpěl ďábelské ódy" -> 'prilis zlutoucky kun upel dabelske ody'

export const removeNonDigits = (str?: string) => str?.replace(/\D/g, "");

const GUID_PATTERN =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export const isGuid = (str: string) => GUID_PATTERN.test(str);
